import React from 'react';

import VerticalCenter from '../../../../elements/VerticalCenter';
import liveVotingCommonScreen from '../../common/LiveVotingScreenHOC';

class InfoScreen extends React.Component {
    render() {
        let {question} = this.props;
        return (
            <VerticalCenter>
                <div className="content text-center" style={{fontSize: '200%'}}>
                    <p className="text main">{question.text}</p>
                    <p className="text">{question.description}</p>
                </div>
            </VerticalCenter>
        );
    }
}

export default liveVotingCommonScreen(InfoScreen);
